import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import { resources } from './i18n-resources/en';

let cacheResources: typeof resources;

// Default nampespace
export const defaultNS = 'app';

// Use navigator as default language for now
const defaultLanguage = navigator.language?.split('-').shift() || 'en';

// Accepted languages
const acceptedLanguages = ['en', 'es', 'pt', 'fr', 'it', 'de'];

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  // We don't load translations externally yet
  .use(ChainedBackend)

  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: [defaultNS],
    defaultNS,

    // Language detection order
    detection: {
      order: ['navigator'],
    },
    lng: defaultLanguage,
    fallbackLng: 'en',
    debug: false, // will turn off in production, process.env.NODE_ENV !== 'production'

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Backend options
    backend: {
      backends: [
        // HttpBackend, // if a namespace can't be loaded via normal http-backend loadPath, then the inMemoryLocalBackend will try to return the correct resources
        resourcesToBackend(
          defaultLanguage === 'en' || !acceptedLanguages.includes(defaultLanguage)
            ? { en: resources }
            : (lng, ns, callback) => {
                const key = ns as keyof typeof cacheResources;
                if (cacheResources) {
                  callback(null, cacheResources[key] || {});
                  return;
                }

                // Skip english resources refetch
                if (lng === 'en') return callback(null, {});

                import(`./i18n-resources/${lng}`).then((resources) => {
                  // Cache resources
                  cacheResources = resources.default;
                  const resourcesWithNs = cacheResources[key];

                  callback(null, resourcesWithNs);
                });
              },
        ),
      ],
      // No backend options for now due to current locale structure not compatible with i18next
      // backendOptions: [
      //   {
      //     loadPath: '/locales/{{lng}}/{{ns}}.json',
      //   },
      // ],
    },
  });

export default i18n;
